
import { translate } from "../app"
import { Container } from "./container"
import { SplitText } from "./splittext"

export function BlockInfo(props: { block: BlockInfo }) {
  const { block } = props

  return <Container block={block}>
    <div className="text-4xl"><SplitText text={translate(props.block.title)} /> </div>
    <div className="text-2xl mt-4 text-gray-500"><SplitText text={translate(props.block.subtitle)} /> </div>
  </Container>
}